import React, { PureComponent } from "react";
import {
  CustomizedYAxisTick,
  Error,
  selectFormat,
  StandardTooltip,
  isDateFromDataInISOFormat,
  getAllKeys,
  formatDateFromData,
} from "./../../Utils/Utils.js";
import {
  ComposedChart,
  Line,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import clsx from "clsx";

class AreaChartLines extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderLegends = () => {
    const legends = [
      { key: "Winbacks", color: "#fc6d52", type: "line" },
      { key: "New Starts", color: "#f89481", type: "area" },
    ];

    return legends.map((entry, i) => (
      <span
        key={i}
        className="legend mt-2 mt-md-0"
        style={{ opacity: entry.opacity || 1 }}
      >
        <span
          className={
            "legend__icon " +
            (entry.type === "line" ? "legend__icon--line" : "")
          }
          style={{
            background: entry.type === "area" ? entry.color : "unset",
            borderTop:
              entry.type === "line" ? "1px dashed " + entry.color : "unset",
          }}
        ></span>
        <span className="legend__text" style={{ color: entry.color }}>
          {entry.key}
        </span>
      </span>
    ));
  };

  getSortedKeys(_data) {
    if (!_data) return [];
    if (!_data[0]) return [];
    const data = _data.filter((d) => d);
    const keys = getAllKeys(data, ["date"]);

    const len = data.length;

    return keys
      .map((key) => ({
        key: key,
        value: data.reduce((accum, curr) => accum + (curr[key] || 0), 0) / len,
      }))
      .sort((a, b) => b.value - a.value)
      .map((d) => d.key);
  }

  getExportData = () => {
    let { data } = this.props.data;
    return {
      data: data,
      opts: {
        type: "chart",
        date: {
          // overwrites the default settings for date only when the date is in ISO format
          defined: isDateFromDataInISOFormat(this.props.data.data),
          format: "YYYY-MM-DDThh:mm:ssZ",
          viewFormat: "YYYY-MM-DD",
        },
      },
    };
  };

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    const widget_data = data.data;

    let preparedData = formatDateFromData(widget_data);

    return (
      <>
        {this.renderLegends(data)}
        <ResponsiveContainer height={300} width="100%">
          <ComposedChart
            data={preparedData}
            margin={{ top: 12, right: 0, bottom: 0, left: 0 }}
          >
            <Tooltip
              cursor={{ fill: "#eee", opacity: 0.5 }}
              content={
                <StandardTooltip
                  render={({ data }) => {
                    const payload = data(this.props);

                    if (payload !== null) {
                      const tooltip_data = payload[0].payload;

                      let total = "";

                      if (tooltip_data.total) {
                        total = tooltip_data.total;
                      } else {
                        total = payload.reduce(
                          (acc, cur) => acc + (cur.value || 0),
                          0
                        );
                      }

                      return (
                        <div className="standard-tooltip">
                          {tooltip_data.date && (
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Date:
                              </span>
                              <span className="standard-tooltip__value-header">
                                {tooltip_data.date}
                              </span>
                            </header>
                          )}
                          <main className="standard-tooltip__main">
                            {Object.keys(payload)
                              .sort(
                                (a, b) => payload[b].value - payload[a].value
                              )
                              .map((key, index) => (
                                <div
                                  className="standard-tooltip__item"
                                  key={key}
                                >
                                  {payload[key].dataKey !== "insights" ? (
                                    <>
                                      <span
                                        className="standard-tooltip__icon"
                                        style={{
                                          background: payload[key].color,
                                        }}
                                      ></span>
                                      <span
                                        className={clsx(
                                          "standard-tooltip__key",
                                          "text-capitalize"
                                        )}
                                        style={{
                                          color: payload[key].color,
                                        }}
                                      >
                                        {payload[key].dataKey.replace("_", " ")}
                                      </span>

                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value,
                                          false ? "0,00" : null
                                        )}
                                      </span>
                                    </>
                                  ) : null}
                                </div>
                              ))}

                            <div className="standard-tooltip__dilimiter1"></div>

                            <div className="standard-tooltip__item">
                              <span
                                className={clsx(
                                  "standard-tooltip__key",
                                  "text-capitalize",
                                  "total"
                                )}
                              >
                                Total{" "}
                              </span>
                              <span className="standard-tooltip__value">
                                {selectFormat(
                                  "number",
                                  total,
                                  false ? "0,00" : null
                                )}
                              </span>
                            </div>
                          </main>
                        </div>
                      );
                    }
                  }}
                />
              }
            />
            <CartesianGrid
              stroke="#FEE5DE"
              strokeDasharray="3 3"
              vertical={false}
            />
            <Area
              type="monotone"
              dataKey="new_starts"
              fill="#f89481"
              stroke="#f89481"
              fillOpacity={0.6}
            />
            <Line
              type="monotone"
              dataKey="winbacks"
              stroke="#fc6d52"
              strokeWidth={2}
              dot={false}
            />
            <XAxis
              dataKey="date"
              axisLine={false}
              tickLine={false}
              // tick={<CustomizedXAxisTickTimeDay />}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={<CustomizedYAxisTick />}
              width={40}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </>
    );
  }
}

export default AreaChartLines;
